import i18n from "@/i18n";
import type {
  ContractStatusCodes,
  IContractStatusMap,
  IContractMappedStatus,
  IStatus
} from "@upmind-automation/types";

export function ContractStatusMap(): Record<
  ContractStatusCodes,
  IContractStatusMap
> {
  return {
    contract_active: {
      name: i18n.t("_.active") as string,
      type: "is-success",
      icon: "check-circle"
    },
    contract_awaiting_activation: {
      name: i18n.t("_.awaiting_activation") as string,
      type: "is-info",
      icon: "power-off"
    },
    contract_cancelled: {
      name: i18n.t("_.cancelled") as string,
      type: "is-dark",
      icon: "times-circle"
    },
    contract_closed: {
      name: i18n.t("_.lapsed") as string,
      type: "is-grey",
      icon: "ban"
    },
    contract_fraud: {
      name: i18n.t("_.fraud") as string,
      type: "is-danger",
      icon: "shield-alt"
    },
    contract_pending: {
      name: i18n.t("_.pending") as string,
      type: "is-warning",
      icon: "sync-alt"
    },
    contract_suspended: {
      name: i18n.t("_.suspended") as string,
      type: "is-danger",
      icon: "pause-circle"
    }
  };
}

export function ContractStatusMapped(status: IStatus): IContractMappedStatus {
  return {
    ...status,
    ...ContractStatusMap()[status.code as ContractStatusCodes]
  };
}
